module.exports = __webpack_public_path__ + "static/media/theme.50a70e40.svg";